export default {"src":"/_next/static/media/onlinePaymentWallet.926c16e7.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};